import React, { useEffect, useMemo } from 'react'
import { DeviceLinkModel, useInstallationConfigurationTabs } from 'src/Libs/installations'
import SerialnumberPanel from 'src/Libs/installations/components/new-installation/configuration/em360/SerialnumberPanel'
import ModbusTcpPanel from 'src/Libs/installations/components/new-installation/configuration/em360/ModbusTcpPanel'
import LimitPowerPanel from 'src/Libs/installations/components/new-installation/configuration/em360/LimitPowerPanel'
import ChargingStrategyPanel from 'src/Libs/installations/components/new-installation/configuration/em360/ChargingStrategyPanel'
import { Stack } from '@mui/material'
import { useProductSerialnumbers } from 'src/Libs/installations/hooks'
import { useEmcStatus } from 'src/Libs/installations/hooks/installation-configuration/em360/use-emc-status'
import { useEmcConfig } from 'src/Libs/flow/installation/hooks'

interface Props {
  installationId?: number
  emcDeviceLink?: DeviceLinkModel
}

const Overview: React.FC<Props> = ({ installationId, emcDeviceLink }) => {
  const { setActiveTab } = useInstallationConfigurationTabs(installationId)

  const [productSerialnumbers, productSerialnumbersLoading, productSerialnumbersError] = useProductSerialnumbers(
    emcDeviceLink?.deviceId ? [emcDeviceLink.deviceId] : undefined
  )

  const em360Serialnumbers = useMemo(() => {
    if (!productSerialnumbers.length) {
      return undefined
    }

    return productSerialnumbers[0]
  }, [productSerialnumbers])

  const emcSerialnumber = em360Serialnumbers?.serialno?.toString()
  const { data: emcStatus, isOnline: isEmcOnline, isLoading: isEmcConnectionLoading, isError: isEmcConnectionError } = useEmcStatus(emcSerialnumber)
  const emcIpAddress = emcStatus?.ipAddress

  const emcDeviceLinkId = emcDeviceLink?.id?.toString() ?? null
  const {
    data: emcConfig,
    isLoading: isEmcConfigLoading,
    isError: isEmcConfigError,
  } = useEmcConfig(installationId, emcDeviceLinkId, !!installationId && !!emcDeviceLinkId)

  useEffect(() => {
    setActiveTab(1)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Stack gap={2}>
      <SerialnumberPanel
        installationId={installationId}
        emcDeviceLink={emcDeviceLink}
        productSerialnumbers={productSerialnumbers}
        isProductSerialnumbersLoading={productSerialnumbersLoading}
        isProductSerialnumbersError={productSerialnumbersError}
        isEmcOnline={isEmcOnline}
        isEmcConnectionLoading={isEmcConnectionLoading}
        isEmcConnectionError={isEmcConnectionError}
      />
      <ModbusTcpPanel
        installationId={installationId}
        emcDeviceLink={emcDeviceLink}
        emcConfig={emcConfig}
        isEmcConfigLoading={isEmcConfigLoading}
        isEmcOnline={isEmcOnline}
        isEmcConnectionLoading={isEmcConnectionLoading}
        emcIpAddress={emcIpAddress}
        isEmcConfigError={isEmcConfigError}
        hasEmcConnectionData={!!emcSerialnumber}
      />
      <ChargingStrategyPanel installationId={installationId} />
      <LimitPowerPanel installationId={installationId} emcDeviceLink={emcDeviceLink} isEmcConnectionLoading={isEmcConnectionLoading} />
    </Stack>
  )
}

export default Overview
